import {IntranetAbsenceRequest} from "@/router/Intranet/IntranetAbsenceRequest.js";
import {IntranetAdminRequest} from "@/router/Intranet/IntranetAdminRequest.js";
import {IntranetClaim} from "@/router/Intranet/IntranetClaim.js";
import {IntranetTrainingRequest} from "@/router/Intranet/IntranetTrainingRequest.js";
import {IntranetBoardingTask} from "@/router/Intranet/IntranetBoardingTask.js";
import {IntranetVacation} from "@/router/Intranet/IntranetVacation.js";
import {IntranetSagePaySlip} from "@/router/Intranet/IntranetSagePaySlip";
import {IntranetWorker} from "@/router/Intranet/IntranetWorker";
import {IntranetRecruitmentRequest} from "@/router/Intranet/IntranetRecruitmentRequest";
import {IntranetEvaluationFilePerformance} from "@/router/Intranet/IntranetEvaluationFilePerformance";
import {AutoEvaluation} from "@/router/Intranet/AutoEvaluation";

export const Intranet = {
    path: '/intranet',
    name: 'intranet',
    component: () => import('@/views/Intranet/IntranetHomePage.vue'),
    children: [
        IntranetAbsenceRequest,
        IntranetAdminRequest,
        IntranetClaim,
        IntranetTrainingRequest,
        IntranetBoardingTask,
        IntranetVacation,
        IntranetSagePaySlip,
        IntranetWorker,
        IntranetRecruitmentRequest,
        IntranetEvaluationFilePerformance,
        AutoEvaluation,
    ],
}